<template>
  <flow-action-card :flow-id="flowId" :item="item" :dismiss="dismiss" />
</template>

<script>
import { mapState } from 'vuex'
import { Modal } from '@argon/app/mixins'
import { NAMESPACE } from '../store'
import { FlowActionCard } from '../components'

export default {
  name: 'flow-action-modal',
  mixins: [Modal],
  components: { FlowActionCard },
  props: {
    flowId: {
      type: [String, Number],
      required: true
    },
    actionName: { type: String, required: true }
  },
  computed: {
    ...mapState(NAMESPACE, ['current']),
    item() {
      return this.current.meta.actions.find((action) => action.name === this.actionName)
    }
  }
}
</script>

<i18n>
{
  "en": {
    "displayName": "@:labels.displayName",
    "editTitle": "Edit Action",
    "newTitle": "New Action",
    "required": "@:labels.required",
    "save": "@:labels.save",
    "type": "Type"
  },
  "fr": {
    "displayName": "@:labels.displayName",
    "editTitle": "Modifier l'action",
    "newTitle": "Nouvelle action",
    "required": "@:labels.required",
    "save": "@:labels.save",
    "type": "Type"
  }
}
</i18n>
